export default {
  articles: state => state.articles,
}
